import React, { Component } from 'react';
import {Card, CardText} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import AccountCircle from 'material-ui/svg-icons/action/account-circle';
import Info from 'material-ui/svg-icons/action/info-outline';
import {greenA700} from 'material-ui/styles/colors'
import FloatingActionButton from 'material-ui/FloatingActionButton';
import CallIcon from 'material-ui/svg-icons/communication/call';
import CallEnd from 'material-ui/svg-icons/communication/call-end';

import Chat from './shared/Chat';
import CallScreen from './shared/CallScreen';
import CallStatus from './shared/CallStatus';
import ContactInfo from './ContactInfo';

class ContactWindow extends Component {
  state = {
    infoShown: false,
  }

  render() {
    const hasConversation = this.props.callStatus === 'calling' || (this.props.calling && this.props.calling.id == this.props.contact.id);
    const showCallStatus = ['stopped', 'recovering', 'calling', 'accepted', 'denied'].indexOf(this.props.callStatus) != -1;

    return (
      <Card zDepth={0} className={"contactWindow" + (this.state.infoShown ? ' infoshown' : '')}
        containerStyle={{
          display:'flex',
          flexDirection: 'column',
          flex: 1,
          padding:0,
          overflow:'hidden'
        }}
        style={{
          backgroundColor: 'transparent',
          flex:1,
          display: 'flex',
          flexDirection: 'column',
          overflow:'hidden'
        }}>
        <div className="contactheader" style={{
          display:'flex',
          alignItems: 'center'
        }}>
          <div className="name">
            <Avatar
              icon={<AccountCircle />}
              size={48}
              style={{display:'inline-block', marginRight: '16px'}}
            />
            <div style={{display:'inline-block'}}>
              <div style={{display:'inline-block'}}>{this.props.contact.name}</div>
              <div style={{marginTop:'0.2em'}}>
                <span style={{color: (this.props.contact.online ? greenA700 : 'red')}}>
                  {this.props.contact.online ? 'Online' : 'Offline'}
                </span>
              </div>
            </div>
          </div>
          <div style={{textAlign: 'left', flex:1, marginLeft: '90px'}}>
            { !hasConversation && this.props.contact.online && this.props.user.id !== this.props.contact.id &&
              <FloatingActionButton
                onClick={() => this.props.onCall(this.props.contact)}
                zDepth={1}
                mini={true}
                disabled={!this.props.contact.online}
                backgroundColor={greenA700}>
                <CallIcon />
              </FloatingActionButton>}
            { hasConversation &&
              <FloatingActionButton
                onClick={() => {
                  if (this.props.callStatus !== 'calling') {
                    this.props.onStopCall();
                  }
                  else {
                    this.props.onAbortCall();
                  }
                }}
                zDepth={1}
                mini={true}
                backgroundColor={'red'}>
                <CallEnd />
              </FloatingActionButton>}
          </div>
          <div className="infoButton" style={{textAlign: 'right', position:'relative'}}>
            <Info
              style={{width:'32px', height:'32px', opacity:0.75, fill: (this.state.infoShown ? 'rgb(0, 120, 154)' : '#999'), cursor:'pointer'}}
              onClick={() => this.setState({infoShown: !this.state.infoShown})} />
          </div>
        </div>
        <CardText style={{
          display:'flex',
          backgroundColor: 'white',
          flex: 1,
          padding:0,
          overflow: 'hidden'
          }}>
          <div className="chatcontainer" style={{
            overflow: 'hidden'
          }}>
            <Chat
              local={this.props.user}
              remote={this.props.contact}
              onMessage={(msg) => this.props.onMessage(this.props.contact, msg)}
              messages={this.props.messages}
              events={this.props.events}
              onMetadataChange={this.props.onChangeCallMetadata}
              metadataInquiries={this.props.metadataInquiries}
              onMessagesUpdate={(messages) => this.props.onMessagesUpdate(messages)}
            />
          </div>
          <div
            className={"callscreencontainer" + (showCallStatus ? ' hasOverlay':'')}
            style={{overflow: 'hidden', position: 'relative'}}>
            <CallScreen
              onError={(kind) => this.props.onError(kind)}
              onMuteRemote={() => this.props.onMuteRemote()}
              onMuteLocal={() => this.props.onMuteLocal()}
              onStopCall={() => this.props.onStopCall()}
              onDisableCam={() => this.props.onDisableCam()}
              onSwitchCam={() => this.props.onSwitchCam()}
              muteRemote={this.props.muteRemote}
              muteLocal={this.props.muteLocal}
              disableCam={this.props.disableCam}
              local={this.props.user}
              remote={this.props.contact}
              audioDevices={this.props.audioDevices}
              videoDevices={this.props.videoDevices}
              callStatus={this.props.callStatus}
              onStreamsRunning={this.props.onStreamsRunning}
            />
            {showCallStatus &&
              <CallStatus
                callStatus={this.props.callStatus}
                onResetCallStatus={() => this.props.clearCallStatus()}
                onStopCall={() => this.props.onStopCall()}
                onAbortCall={() => this.props.onAbortCall()}
              />
            }
          </div>
          <div className="infoContainer">
            <ContactInfo
              contact={this.props.contact}
              locale={this.props.locale}
              callMetadata={this.props.callMetadata}
              callMetadataValues={this.props.callMetadataValues}
              onChangeCallMetadata={this.props.onChangeCallMetadata}
            />
          </div>
        </CardText>
      </Card>
    )
  }
};

export default ContactWindow;


// WEBPACK FOOTER //
// ./src/ContactWindow.js